import { useState } from "react";
import { fileUrl, ensureDownloadToken } from "@/lib/api";

// <img> that transparently refreshes the short-lived download token and retries once on error
export function AuthImage({ fileId, w, ...props }) {
  const [src, setSrc] = useState(() => fileUrl(fileId, w));
  const [retried, setRetried] = useState(false);

  const handleError = async () => {
    if (retried) return;
    setRetried(true);
    await ensureDownloadToken().catch(() => {});
    setSrc(`${fileUrl(fileId, w)}&t=${Date.now()}`);
  };

  return <img src={src} onError={handleError} loading="lazy" decoding="async" {...props} />;
}
